import { Helper } from '../../../js/util/helper';

export default class Metanavigation {
  constructor( node ) {
    this.node = node;
    this.open = this.node.querySelector( '.metanavigation__current-lang' );
    if ( this.open ) {
      this.addEventListener();
    }
  }
  addEventListener() {
    this.open.addEventListener( 'click', () => {
      const layer = this.node.querySelector( '.metanavigation__lang' );
      if ( layer ) {
        layer.classList.toggle( 'metanavigation__lang--open' );
      }
    });

    window.addEventListener( 'click', ( e ) => {
      const isLanguageSwitch = Helper.getClosest( e.target, '.metanavigation' );
      const layer = this.node.querySelector( '.metanavigation__lang--open' );
      if ( layer && !isLanguageSwitch ) {
        layer.classList.toggle( 'metanavigation__lang--open' );
      }
    });
  }
}
